import 'slick-carousel/slick/slick.css';

import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'react-slick';
import styled, { css } from 'styled-components';

import { useConfig } from '../../hooks';
import IconPrev from '../Icons/ChevronLeft';
import IconNext from '../Icons/ChevronRight';
import NavigationButton from './NavigationButton';

const CarouselWrapper = ({ children, isVisibleButtons }) => {
  const { button } = useConfig();

  function NextSlideButton(props) {
    // eslint-disable-next-line react/prop-types
    const { onClick, currentSlide, slideCount } = props;
    return (
      <NextButton
        onClick={onClick}
        textColor={button.color}
        textHoverColor={button.hoverColor}
        isHidden={currentSlide + 1 === slideCount || !isVisibleButtons}
        data-role="none"
      >
        <IconNext />
      </NextButton>
    );
  }

  function PrevSlideButton(props) {
    // eslint-disable-next-line react/prop-types
    const { onClick, currentSlide } = props;
    return (
      <PrevButton
        onClick={onClick}
        textColor={button.color}
        textHoverColor={button.hoverColor}
        isHidden={currentSlide === 0 || !isVisibleButtons}
        data-role="none"
      >
        <IconPrev />
      </PrevButton>
    );
  }

  const settings = {
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    nextArrow: <NextSlideButton />,
    prevArrow: <PrevSlideButton />
  };

  return (
    <Root>
      <Slider {...settings}>{children}</Slider>
    </Root>
  );
};

CarouselWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  isVisibleButtons: PropTypes.bool
};

CarouselWrapper.defaultProps = {
  isVisibleButtons: true
};

const Root = styled.div`
  .slick-track {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
  }

  .slick-list {
    padding: 2px 0;
    margin: 0 -4px;
  }

  .slick-slide {
    width: 228px;
    height: auto;
    padding: 0 4px;
  }

  .slick-slide > div {
    height: 100%;
  }
`;

const PrevButton = styled(NavigationButton)`
  left: 0;
  border-radius: 0 4px 4px 0;

  ${({ isHidden }) =>
    isHidden &&
    css`
      display: none;
    `}
`;

const NextButton = styled(NavigationButton)`
  right: -4px;
  border-radius: 4px 0 0 4px;

  ${({ isHidden }) =>
    isHidden &&
    css`
      display: none;
    `}
`;

export default CarouselWrapper;
